import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { TextField } from "@/shared/components/Form/TextField";
import { ColorPickerField } from "@/shared/components/Form/ColorPickerField";
import { ImageField } from "@/shared/components/Form/ImageField";
import type {
  PlatformBlockComponent,
  PlatformBlockProps,
} from "../../../types";
import { BlockFormHeader } from "../BlockFormHeader";

export const Banner: PlatformBlockComponent = ({
  name,
}: PlatformBlockProps) => {
  const { t } = useTranslation();

  return (
    <Paper sx={{ p: 2 }}>
      <BlockFormHeader blockType="BANNER" />
      <Grid container spacing={2}>
        <Grid size={12}>
          <ImageField
            name={`${name}.bannerId`}
            imageType="banner"
            label={t("platformBlocks.fields.image")}
          />
        </Grid>
        <Grid size={12}>
          <TextField
            name={`${name}.link`}
            label={t("platformBlocks.fields.link")}
            type="text"
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <ColorPickerField
            name={`${name}.backgroundColor`}
            label={t("platformBlocks.fields.backgroundColor")}
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            name={`${name}.maxWidth`}
            label={t("platformBlocks.fields.maxWidth")}
            type="number"
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            name={`${name}.paddingTop`}
            label={t("platformBlocks.fields.paddingTop")}
            type="number"
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            name={`${name}.paddingBottom`}
            label={t("platformBlocks.fields.paddingBottom")}
            type="number"
            fullWidth
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
